<template>
  <div
    ref="work"
    @click="focusAndSendInfo"
    @mouseenter="sendInfo"
    @mouseout="blur"
    class="content-block"
    :class="{ focus: focused }"
    target="_blank"
    :href="site.url"
    :style="{ 'animation-delay': site.animationDelay + 's' }"
  >
    <div
      class="content-wrapper"
      :style="{ 'background-image': 'url(' + site.image.url + ')' }"
      :class="site.modifier"
    >
      <div class="actions">
        <p class="title">
          <template v-if="site.shortenedTitle">
            {{ site.shortenedTitle }}
          </template>
          <template v-else>
            {{ site.title }}
          </template>
        </p>
        <div class="action-wrap">
          <div
            tabindex="0"
            class="read-about"
            @focus="focus"
            @blur="blur"
            @click="openInfo"
            @keydown.enter="openInfo"
          >
            <app-info-icon></app-info-icon>
            <p>Details</p>
          </div>
          <a
            v-if="site.url.url"
            :href="site.url.url"
            target="_blank"
            class="go-to"
            @focus="focus"
            @blur="blur"
            rel="noopener noreferrer"
          >
            <app-website-icon></app-website-icon>
            <p>Website</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Website from "./svg/Website.vue";
import Info from "./svg/Info.vue";
export default {
  data() {
    return {
      focused: false,
      infoSent: false
    };
  },
  props: ["site"],
  components: {
    appWebsiteIcon: Website,
    appInfoIcon: Info
  },
  methods: {
    adjustSizes() {
      let block = this.$refs.work;
      let width = block.offsetWidth;
      block.style.height = `${width * 0.47}px`;
    },
    focus() {
      this.focused = true;
      if (!this.infoSent) {
        this.sendInfo();
      }
    },
    blur() {
      this.focused = false;
    },
    sendInfo() {
      this.$emit("cacheVideo", this.site);
      this.infoSent = true;
    },
    openInfo() {
      this.$emit("openInfo");
    },
    focusAndSendInfo() {
      this.focus();
      this.sendInfo();
    }
  },
  mounted() {
    this.adjustSizes();
    this.$nextTick(function() {
      window.addEventListener("resize", this.adjustSizes);
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.adjustSizes);
  }
};
</script>
